import { estaContido, validarPermalink, validarQtdeCaractere } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosPermalink = () => {
  const criterios = [
    {
      texto: 'O permalink deve conter entre 1 e 76 caracteres',
      otimizado: false,
    },
    {
      texto: 'Este campo não pode estar vazio',
      otimizado: false,
    },
    {
      texto: 'O permalink deve conter a palavra-chave',
      otimizado: false,
    },
    {
      texto: 'O permalink deve conter o slug',
      otimizado: false,
    },
    {
      texto: 'O permalink deve ser igual à URL esperada',
      otimizado: false,
    },
  ];

  function validacoes(index, permalink, palavraChave, slug) {
    switch (index) {
      case 0:
        return validarQtdeCaractere(permalink, 1, 76);
      case 1:
        return permalink !== null && permalink !== undefined && permalink.length > 0;
      case 2:
        return estaContido(palavraChave, permalink);
      case 3:
        return estaContido(slug, permalink);
      case 4:
        return validarPermalink(permalink, slug);
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
